var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',{attrs:{"label":_vm.label,"items":_vm.salutations,"item-text":"displayName","error":_vm.hasErrors('salutation'),"error-messages":_vm.getErrors('salutation'),"hide-details":_vm.hideDetails},model:{value:(_vm.selectedSalutation),callback:function ($$v) {_vm.selectedSalutation=$$v},expression:"selectedSalutation"}})
}
var staticRenderFns = []

export { render, staticRenderFns }